// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    GetUnfilteredProducts,
    ParseQueryParameter,
    PopulateApiParameter,
    SendTracking,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { xGoogleAnalyticsState } from "@west/App/Store/Reducers";
import { googleAnalyticsSearchTracking } from "@west/XDL/Utilities/tracking";
import qs from "qs";

// XNG-Change: add properties to expand
export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const expands = (props.apiParameter.expand || []).concat(["properties"]);
    props.apiParameter.expand = [...new Set(expands)];
};

export const XngGetUnfilteredProducts: typeof GetUnfilteredProducts = props => {
    delete (props.apiParameter as { isStocked?: boolean }).isStocked;
};

export const XngParseQueryParameter: typeof ParseQueryParameter = props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    const { isStocked } = parsedQuery;

    if (isStocked !== undefined) {
        (props.result.productFilters as { isStocked?: boolean }).isStocked = true;
    }
};

export const XngSendTracking: typeof SendTracking = props => {
    const { search } = props.apiParameter;

    if (!search) {
        return;
    }

    const state = props.getState();
    const pagination = getProductListDataViewProperty(state, "pagination");
    const originalQuery = getProductListDataViewProperty(state, "originalQuery");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    googleAnalyticsSearchTracking(
        (state as xGoogleAnalyticsState).xGoogleAnalytics,
        originalQuery || "",
        pagination?.totalItemCount || 0,
        correctedQuery,
    );
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
addToChainAfter(chain, ParseQueryParameter, XngParseQueryParameter);
replaceInChain(chain, SendTracking, XngSendTracking);
